import style from "./TextClip.module.css";

function TextClip({ children, type, show }) {
  const styleArray = [];

  if (show === true) {
    styleArray.push(style.animation);
    if (type === 0) {
      styleArray.push(style.TextClip);
    } else if (type === 1) {
      styleArray.push(style.FadeOutText);
    } else if (type === 2) {
      styleArray.push(style.fadeUp);
    }
  }

  return <div className={styleArray.join(" ")}>{children}</div>;
}

export default TextClip;
